import { render, staticRenderFns } from "./Agroindustria.vue?vue&type=template&id=84acb006"
import script from "./Agroindustria.vue?vue&type=script&lang=js"
export * from "./Agroindustria.vue?vue&type=script&lang=js"
import style0 from "./Agroindustria.vue?vue&type=style&index=0&id=84acb006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports